/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import "./Login.css";
  // Import eye icons

import { config } from "../../utils/config";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Mail, Phone,Eye } from "lucide-react";


function Login(props) {

  const [showPassword, setShowPassword] = useState(false);  // State to toggle password visibility
  const [state, setState] = useState({
    username: "",
    password: "",
  });
  const navigate = useNavigate();

  const goToDashboard = () => {
    navigate("/dashboard");
  };

  const handleChange = (evt) => {
    const value = evt.target.value;
    setState({
      ...state,
      [evt.target.name]: value,
    });
  };

  useEffect(() => {
    const handleResize = () => {
      const image = document.getElementById("logo-image");
      if (window.innerWidth < 768) {
        image.style.display = "none";
      } else {
        image.style.display ="block";
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOnSubmit = (evt) => {
    evt.preventDefault();
   
    const { username, password } = state;

    if (username === "" || password === "") {
      toast.warn("Please Fill The Fields");
    } 
    else if (username === undefined || password === undefined) {
      toast.warn("Please Fill The Fields");
    } 
    else if (username === 'smtech' && password === 'smtech1') {
      window.localStorage.setItem("user", username);
      props.setToken("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VybmFtZSI6ImRlbW8iLCJpZCI6MiwiZXhwIjoxNzE4NjU5NTI2fQ.2fzabIUw6PLny5r5PuRfvk3_G-i8TF3hqtIjJk_DsHM");
        goToDashboard();
      }
       else {
        alert('Invalid username or password');
      }
    
     
    
  }
  
  const handleKeyDown = (evt) => {
    if (evt.key === "Enter") {
      handleOnSubmit(evt);
    }
  };

  return (
    <div className="_form-05-box span-0 m-0">
      <div className="row login-edit" style={{ height: "100vh" }}>
        <div className="Left-side col relative px-0">
          <div
            style={{ color: "white", paddingLeft: '10px' }}
            className="form-05-box-a w-100 h-100 position-relative d-flex flex-column align-items-center"
          >
            <div className="_form_05_logo mt-5">
              <h2 className="text-uppercase">SMTECH-LICENSES</h2>
              <span className="text-sm">
            Product Licensing and Monetization Platform
              </span>
            </div>
            <div className="below position-absolute bottom-0">
              <div className="d-flex flex-column align-items-center justify-content-center text-red">
                <span className="text-uppercase font-sm">
                  Powered By Smart Tech Pvt.Ltd
                </span>
                <span>Tinkune, Kathmandu, Nepal</span>
                <span>
                  <Mail color="green" size="25px" />
                  info@smtechme.com
                </span>
                <span>
                  <Phone color="green" size="20px" />
                  +977-9851186839
                </span>
                <span>
                  <span>Retail 1.0.0</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          className="leftBar"
          style={{
            backgroundColor: '#122C53',
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            width: "70%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
       
         
            
                <div
                  className="sideform"
                  style={{
                    borderRadius: "20px",
                    width: "55%",
                    height: "62%",
                    backgroundColor: "#122C53",
                    marginBottom: "100px",
                  }}
                >
                  <>
                    <div className="main-header">
                      <h2 style={{ color: "white" }}>Login to your account</h2>
                    </div>

                    <div
                      className="form-group"
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <div className="w-75">
                        <label
                          htmlFor="username"
                          className="text-danger fw-bold"
                          style={{ alignItems: "center" }}
                        >
                          Username
                        </label>
                        <input
                          name="username"
                          className="form-control"
                          type="text"
                          placeholder="Username"
                          required=""
                          aria-required="true"
                          value={state.username}
                          onChange={handleChange}
                          onKeyDown={handleKeyDown}  // Added event handler
                        />
                      </div>
                    </div>

                    <div
                      className="form-group"
                      style={{
                        width: "100%",
                        color: "white",
                        display: "flex",
                        justifyContent: "center",
                        position: "relative",  // Added for eye icon positioning
                      }}
                    >
                      <div className="w-75 position-relative">
                        <label className="text-danger fw-bold" htmlFor="password">
                          Password
                        </label>
                        <div className="input-container">
                          <input
                            type={showPassword ? "text" : "password"}  // Toggle input type
                            name="password"
                    
                            className="form-control"
                            placeholder="Enter Password"
                            required=""
                            aria-required="true"
                            value={state.password}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}  // Added event handler
                            onCopy={(e) => e.preventDefault()}  // Disable copy
                            onCut={(e) => e.preventDefault()}   // Disable cut
                            onPaste={(e) => e.preventDefault()} // Disable paste
                            onContextMenu={(e) => e.preventDefault()} // Disable right-click context menu
                          />
                          <span
                            className="password-toggle-icon"
                            onClick={() => setShowPassword(!showPassword)}  // Toggle showPassword state
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "10px",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              color: "#aaa",
                              paddingTop:'15px'
                            }}
                          >
                            {showPassword ? <Eye size={24} /> : <Eye  size={24}/>}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      className="form-group"
                      style={{
                        width: "100%",
                        color: "white",
                        display: "flex",
                        justifyContent: "center",
                        padding: '0px'
                      }}
                    >
                      <Button
                        className="login-button btn btn-success w-75"
                        onClick={handleOnSubmit}
                      >
                        Login
                      </Button>
                    </div>
                   
                  </>
                </div>
              
        
    
        </div>
      </div>
    </div>
  );
}

export default Login;
